export * from '@databases/utils/constants';

export const CONFLUENCE_SUPPORT_URL =
  'https://support.atlassian.com/confluence-cloud/docs/create-and-edit-databases/';

export const TABLE_CLASSNAMES = {
  IS_SELECTED: 'isSelected',
  IS_SOFT_SELECTED: 'isSoftSelected',
  IS_INVALID: 'isInvalid',
  SHOW_AS_DRAGGING: 'showAsDragging',
  SHOW_AS_DISABLED: 'showAsDisabled',
  IS_SKELETON_ENABLED: 'isSkeletonEnabled',
  IS_TOP_ADJACENT_SELECTED: 'isTopAdjacentSelected',
  IS_BOTTOM_ADJACENT_SELECTED: 'isBottomAdjacentSelected',
  IS_LEFT_ADJACENT_SELECTED: 'isLeftAdjacentSelected',
  IS_RIGHT_ADJACENT_SELECTED: 'isRightAdjacentSelected',
  IS_HOVER_DELETE_BUTTON: 'isHoverDeleteButton',
  HIDE_BORDER_ON_FOCUS: 'hideBorderOnFocus',
  MAXIMIZE_HEIGHT: 'maximizeHeight',
  SELECT_BUTTON: 'selectButton',
  ACTIVE_DRAG_HANDLER_ICON: 'activeDragHandlerIcon',
  DRAG_HANDLER_ICON: 'dragHandlerIcon',
  ACTIONS: 'actions',
  ADD_FIELD: 'addField',
  INSERT_COLUMN_BEFORE: 'insertColumnBefore',
  INSERT_COLUMN_AFTER: 'insertColumnAfter',
} as const;
